module.exports = __webpack_public_path__ + "static/media/bg_001.64472996.png";